export const FIXED_FEE = 'fixed'
export const LOCATION_BASED_FEE = 'locationBased'
export const PAY_INSTORE_FEE = 'PAY_INSTORE'
export const SHOPDM_REPLACE_ITEMS_FEE = 'SHOPDM_REPLACE_ITEMS'
export const SHOPDM_REPLACE_DELIVERY_FEE = 'SHOPDM_REPLACE_DELIVERY'